module.exports = __webpack_public_path__ + "static/media/Monday.e4e4d67f.webp";